<template>
  <form
    class="c-site-search-bar"
    v-on:submit.prevent="gotoSearch"
    :class="{ inline: inline }"
  >
    <label for="site-search-text" class="screen-reader-text">Search</label>
    <input
      type="text"
      placeholder="Search here"
      id="site-search-text"
      v-model="searchQuery"
      ref="search"
    />
    <form-multiselect
      v-model="searchType"
      :options="options"
      :searchable="false"
      :close-on-select="false"
      :show-labels="false"
      placeholder="Type"
      show-drop-icon
      class="c-site-search-bar__dropdown ta-left"
    ></form-multiselect>

    <base-button :primary="true" square type="submit" aria-label="Search">
      <icon name="search" alt="Search icon" />
      <span class="screen-reader-text">Search</span>
    </base-button>
  </form>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapState } from 'vuex';

export default {
  name: 'SiteSearchBar',

  props: {
    inline: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      searchText: '',
      value: '',
      options: ['All', 'Pages', 'Events', 'Questions', 'News'],
    };
  },
  computed: {
    searchQuery: {
      get() {
        return this.$store.state.search.searchQuery;
      },
      set(newVal) {
        this.$store.commit('search/SET_QUERY', newVal);
      },
    },
    searchType: {
      get() {
        return this.$store.state.search.searchType;
      },
      set(newVal) {
        this.$store.commit('search/SET_TYPE', newVal);
      },
    },
  },
  methods: {
    gotoSearch() {
      if (this.$route.name == 'Search') {
        // if we are on the search page, we need to store details in storage and reload the page
        if (window.localStorage) {
          window.localStorage.setItem(
            'mftSiteSearch',
            JSON.stringify({
              searchQuery: this.searchQuery,
              searchType: this.searchType,
            }),
          );
          // try catch in case we are trying to load the same route
          try {
            this.$router.push({
              name: 'Search',
              query: { search: this.searchQuery, type: this.searchType },
            });
          } catch (err) {
            console.log('🚀 ~ file: SiteSearchBar.vue ~ line 90 ~ gotoSearch ~ err', err);

            this.$router.go();
          }
        }
      } else {
        // else we can just transition as normal
        this.$router.push({
          name: 'Search',
          query: { search: this.searchQuery, type: this.searchType },
        });
      }
    },
  },
};
</script>

<style lang="scss">
.c-site-search-bar {
  height: 33px;
  display: inline-flex;
  margin-right: 10px;
  max-width: calc(100vw - 20px);


  &.inline {
    height: auto;
  }

  &__dropdown {
    border: none;
    width: 135px;

    .multiselect__tags {
      border: none;
      border: 1px solid $colour-nhs-pale-grey;
      height: 50px;
      min-height: 50px;
      box-sizing: border-box;
      border-radius: 0;
    }

    .multiselect--active {
      .multiselect__tags {
        border: 2px solid $colour-nhs-core-blue;
      }
    }

    .c-form-field__drop-icon {
      height: 50px;
    }
  }

  input,
  button {
    box-sizing: border-box;
    padding: 10px;
    height: 50px;
  }

  input {
    border-radius: 72px 0 0 72px;
    border: 1px solid $colour-nhs-pale-grey;
    border-right: 0;
    width: 242px;

   @media screen and (min-width: 768px) {
         width: 170px;
   }
   @media screen and (min-width:992px) {
          width: 242px;
   }
   @media screen and (min-width:1024px) {
          width: 236px;
   }
  @media screen and (min-width:1151px) {
          width: 205px;
   }
  @media screen and (min-width:1251px) {
          width: 242px;
   }
  }

  button {
    padding: 11px 0;
    width: auto;
    border-radius: 0 72px 72px 0;
    width: 50px;
    box-sizing: border-box;
  }
}
</style>
